import { useMutation } from "@apollo/client";
import {
  DeleteClientServiceProfileDocument,
  ClientServiceProfileByFiltersDocument,
  ClientServiceProfileStatusesEnum,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";

export const useDeleteClientServiceProfileMutation = () => {
  const mutation = useMutation(DeleteClientServiceProfileDocument, {
    refetchQueries: [
      {
        query: ClientServiceProfileByFiltersDocument,
        variables: {
          filters: {
            clientId: useAuthState.getState().data.userInfo.id,
            status: ClientServiceProfileStatusesEnum.Active,
          },
        },
      },
    ],
  });

  return mutation;
};
